<template>
  <main>
    <!-- <topbar></topbar> -->
    <navbar active="3" @changeTab="changeTab"></navbar>

    <div class="container mgt_108">
      <k-select
        :selected="work_order_status"
        :options="stateList"
        @selectedOption="selectState"
        class="code-area"
        :holderText="$t('service.allRecord')"
      ></k-select>

      <div class="work_order_list">
        <repoItem
          v-for="(i, n) in work_order_list"
          :key="n"
          :item-data="i"
        ></repoItem>
      </div>
      <div class="empty-data" v-if="work_order_list.length == 0 && !loading">
        {{ $t("service.emptyData") }}
      </div>

      <pagination
        v-if="pageCount > 1"
        :active="page_num"
        :count="pageCount"
        @changePage="pageHandle"
      ></pagination>
    </div>

    <!-- <bottombar></bottombar> -->
    <h5-nav v-if="$region !== 'jp'"></h5-nav>
  </main>
</template>

<script>
// import topbar from '@/component/topbar_h5/index.vue';
import navbar from "./component/navbar";
// import bottombar from '@/component/bottombar_h5/index.vue';
import h5Nav from "@/component/h5nav/komoe";
import kSelect from "./component/select";
import repoItem from "./component/repoItem";
import pagination from "./component/pagination";

export default {
  name: "index",
  data() {
    return {
      stateList: [
        {
          id: 1,
          val: this.$t("service.noReply"),
        },
        {
          id: 2,
          val: this.$t("service.processing"),
        },
        {
          id: 3,
          val: this.$t("service.replied"),
        },
        {
          id: 4,
          val: this.$t("service.closedCases"),
        },
      ],
      work_order_status: "",
      work_order_list: [],
      pageCount: 1,
      page_num: 1,
      page_size: 20,
      loading: false,
    };
  },
  components: {
    // topbar,
    // bottombar,
    navbar,
    kSelect,
    repoItem,
    pagination,
	h5Nav
  },
  asyncComputed: {},
  methods: {
    selectState(i) {
      if (this.work_order_status !== i.id) {
        this.page_num = 1;
      }
      this.work_order_status = i.id;
      this.getOrderList();
    },
    pageHandle(i) {
      this.page_num = i;
      this.getOrderList();
    },
    getOrderList() {
      this.loading = true;
      // 请求工单列表
      this.$apis.service
        .getWorkOrder(
          this.work_order_status,
          this.page_num,
          this.page_size,
          this.$utils.token("joy_jct")
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.work_order_list = res.data.data.result;
            this.pageCount = Math.ceil(res.data.data.count / 20);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 切换导航栏
    changeTab(url) {
      this.$router.push({
        path: url,
      });
    },
  },
  mounted: function() {
    this.getOrderList();
  },
};
</script>

<style lang="scss">
@import "../../scss/common_h5.scss";
</style>
<style lang="scss" scoped>
.work_order_list {
  margin: 0.2rem 0;
  overflow: hidden;
}
.empty-data {
  text-align: center;
  font-size: 0.12rem;
  color: #bdbdbd;
}
</style>
